<template>
  <div id="app">
    <div class="index-cont">
      <div class="logo fl pt40">
        <a href="http://www.hanyuan.gov.cn">
          <img src="../assets/img/whiteLogo.png" alt="" />
        </a>
      </div>
      <div class="title-text">
        <p>————————————————————<span style="font-weight: bold;">&nbsp;&nbsp;专题简介&nbsp;&nbsp;</span>————————————————————
        </p>
        <p class="detail">
          为进一步推进汉源县政府门户网站“深化政务公开促进基层政府治理能力提升”建设，增强政务公开工作力度，提高群众对政府工作的满意度，汉源县围绕政务公开相关工作，紧扣政务服务、教育资源、医疗卫生、养老服务主题，打造政务公开便民地图,打通服务群众“最后一公里”。
        </p>
      </div>
    </div>
    <!-- <div class="banner" style="height: auto">
      <img style="width: 100%; height: auto" src="../assets/img/banner.png" alt="" />
    </div> -->
    <div class="main">
      <div class="main_left">
        <!-- 地图分类导航 -->
        <div class="mapNavBar">
          <ul>
            <li v-for="(item, index) in mapTypeList" :class="showList == index ? 'on' : ''" :key="index"
              @click="changeList(item, index)">
              {{ item.name }}
            </li>
          </ul>
        </div>
        <map-container ref="map" :mapData="mapData" :type="queryPrams.type"></map-container>
        <div class="MapLogo">
          政务公开地图
        </div>
      </div>
      <div class="main_right">
        <div class="searchBox">
          <el-input v-if="queryPrams.type == 0" style="margin: 0 25px -9px 9px;" placeholder="输入关键字查找地点或事项"
            v-model.trim="keywords" @keyup.enter.native="searchFn(keywords)">
            <i slot="suffix" class="el-input__icon el-icon-search" @click="searchFn(keywords)"
              style="cursor: pointer;"></i>
          </el-input>
          <el-input v-else style="margin: 0 25px -9px 9px;" placeholder="输入关键字查找地点" v-model.trim="keywords"
            @keyup.enter.native="searchFn(keywords)">
            <i slot="suffix" class="el-input__icon el-icon-search" @click="searchFn(keywords)"
              style="cursor: pointer;"></i>
          </el-input>
        </div>
        <div id="searchTips" style="padding: 0 10px" :style="{ display: display }">
          <span style="color: red">请输入正确的搜索内容！</span>
        </div>
        <div class="main_left_tab3" v-loading="loading"
        element-loading-text="数据正在加载...">
          <div class="zhengwu" style="display: block">
            <ul id="xzfwdt" class="zhengwu1 addlist" style="display: none" v-show="showAddresslist && showAdd">
              <li style="cursor: pointer;" v-for="(item, index) in Addresslist" :key="index" @click="showInfo(item)">
                <p>
                  <span style="font-size: 18px" :title="item.name">{{ item.name }}</span>
                  <!-- <a class="banshiBtn" href="javascript:;">办事指南</a> -->
                </p>
                <p><b>电话：</b>{{ item.phoneNumbe ? item.phoneNumbe : '暂无' }}</p>
                <p><b>地址：</b>{{ item.address ? item.address : '暂无' }}</p>
                <p v-if="item.workTime"><b id="126">办公时间：</b>{{ item.workTime }}</p>
                <a style="color:#0090ff" @click="toDisclosure(item)"
                  v-show="item.isItem == 1 || item.name == '汉源县政务服务中心'">事项公开 <i
                    class="el-icon-d-arrow-right"></i></a>
                <!-- <router-link :to="{ name: 'Disclosure', params: { deptId: item.deptMatterList[0].deptId, topTitle: item.name } }"
                  style="color:#0090ff" v-show="item.deptMatterList.length > 0">事项公开 <i
                    class="el-icon-d-arrow-right"></i></router-link> -->
              </li>
            </ul>
            <ul id="xzfwdt" class="zhengwu1 addlist" style="display: block"
              v-show="!showAddresslist && showAdd && SMAddressList.length > 0">
              <p class="type-title">地点</p>
              <li style="cursor: pointer;" v-for="(item, index) in SMAddressList" :key="index" @click="showInfo(item)">
                <p>
                  <span style="font-size: 18px" :title="item.name">{{ item.name }}</span>
                  <!-- <a class="banshiBtn" href="javascript:;">办事指南</a> -->
                </p>
                <p><b>电话：</b>{{ item.phoneNumbe ? item.phoneNumbe : '暂无' }}</p>
                <p><b>地址：</b>{{ item.address ? item.address : '暂无' }}</p>
                <p v-if="item.workTime"><b id="126">办公时间：</b>{{ item.workTime }}</p>
                <a style="color:#0090ff" @click="toDisclosure(item)"
                  v-show="item.isItem == 1 || item.name == '汉源县政务服务中心'">事项公开 <i
                    class="el-icon-d-arrow-right"></i></a>
                <!-- <router-link :to="{ name: 'Disclosure', params: { topTitle: item.name } }" style="color:#0090ff"
                  v-show="item.name == '汉源县政务服务中心'">事项公开 <i class="el-icon-d-arrow-right"></i></router-link> -->
              </li>
              <p class="more-tips" @click="showMoreAdd">更多地点></p>
            </ul>

            <ul id="xzfwdt" class="zhengwu1 fwlist" style="display:block;"
              v-if="!showServiceList && showSer && SMServiceList.length > 0">
              <p class="type-title">事项</p>
              <li style="cursor: pointer;" v-for="(item, index) in SMServiceList" :key="index"
                @click="showServiceInfo(item)">
                <p class="service-titleBox">
                  <span class="service-titleBox-title" :title="item.name">{{ item.name }}</span>
                  <a class="banshiBtn" @click="toDetail(item.deptMatterId, item.name)">办事指南</a>
                </p>
                <p><b>办理部门：</b>{{ item.deptName }}</p>
                <p><b id="126">办公时间：</b>{{ item.handleTime ? item.handleTime : '暂无' }}</p>
                <p><b>电话：</b>{{ filterNumber(item.consultingPhone) }}</p>
                <!-- <p><b>地址：</b>{{ item.handleAddress ? item.handleAddress : '暂无' }}</p>
                <p><b>办理部门：</b>{{ item.deptName }}</p> -->
                <!-- <router-link to="/Disclosure" style="color:#0090ff">事项公开 <i class="el-icon-d-arrow-right"></i></router-link> -->
              </li>
              <p class="more-tips" @click="showMoreService">更多事项></p>
            </ul>
            <ul id="xzfwdt" class="zhengwu1 fwlist" style="display:none;" v-show="showServiceList && showSer">
              <p class="type-title">事项</p>
              <li style="cursor: pointer;" v-for="(item, index) in ServiceList" :key="index"
                @click="showServiceInfo(item, index)">
                <p class="service-titleBox">
                  <span class="service-titleBox-title" :title="item.name">{{ item.name }}</span>
                  <a class="banshiBtn" @click="toDetail(item.deptMatterId, item.name)">办事指南</a>
                </p>
                <p><b>办理部门：</b>{{ item.deptName }}</p>
                <p><b id="126">办公时间：</b>{{ item.handleTime ? item.handleTime : '暂无' }}</p>
                <p><b>电话：</b>{{ filterNumber(item.consultingPhone) }}</p>
                <!-- <p><b>地址：</b>{{ item.address ? item.address : '暂无' }}</p>
                <p><b>办理地点：</b>{{ item.name }}</p> -->
                <!-- <router-link to="/Disclosure" style="color:#0090ff">事项公开 <i class="el-icon-d-arrow-right"></i></router-link> -->
              </li>
            </ul>
            <p v-if="Addresslist.length < 1 && ServiceList.length < 1 && !loading" style="color: gray; font-size: 14px;line-height: 150px">
              暂未搜索到相关信息，请确认后重新输入！
            </p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import MapContainer from "@/components/MapContainer/MapContainer";
import { queyrList, matterMapQuery, wxLogin, unauthorized } from "@/api/map/index";
export default {
  name: "index",
  components: { MapContainer },
  data() {
    return {
      queryPrams: {
        address: "",
        name: "",
        type: 0,
      },
      Addresslist: [], //海量点根据经纬度组成的数组
      keywords: "", //搜索关键词
      mapTypeList: [
        {
          type: 0,
          name: "政务服务",
        },
        {
          type: 1,
          name: "教育资源",
        },
        {
          type: 3,
          name: "医疗卫生",
        },
        {
          type: 2,
          name: "养老服务",
        },
      ],
      ServiceList: [],  //搜索服务列表
      loading: true,
      showList: false, //当前的点击地图类别
      SMServiceList: [],
      SMAddressList: [],
      display: "none",
      showServiceList: false,  //展示更多事项
      showAddresslist: true,  //展示更多地点
      showAdd: true,
      showSer: true,
      ServiceMap: [],  //服务点位
      dataParms: {
        code: ''
      },
      // 点位列表，路由入口
      serviceMapList: [
        { name: '汉源', linkName: 'HanYuan' },
        { name: '富庄', linkName: 'FuZhuang' },
        { name: '富泉', linkName: 'FuQuan' },
        { name: '小堡', linkName: 'XiaoBao' },
        { name: '顺河', linkName: 'ShunHe' },
        { name: '马烈', linkName: 'MaLie' },
        { name: '富乡', linkName: 'FuXiang' },
        { name: '宜东', linkName: 'YiDong' },
        { name: '安乐', linkName: 'AnLe' },
        { name: '皇木', linkName: 'HuangMu' },
        { name: '大树', linkName: 'DaShu' },
        { name: '九襄', linkName: 'JiuXiang' },
        { name: '河南', linkName: 'HeNan' },
        { name: '富林', linkName: 'FuLin' },
        { name: '片马', linkName: 'PianMa' },
        { name: '晒经', linkName: 'ShaiJin' },
        { name: '清溪', linkName: 'QingXi' },
        { name: '唐家', linkName: 'TangJia' },
        { name: '前域', linkName: 'QianYu' },
        { name: '乌斯', linkName: 'WuSiHe' },
        { name: '永利', linkName: 'YongLi' },
        { name: '坭美', linkName: 'NiMei' },
      ]
    };
  },
  computed: {
    mapData() {
      let list = this.Addresslist.concat(this.ServiceMap);
      var n = []; //一个新的临时数组
      //遍历当前数组
      for (var i = 0; i < list.length; i++) {
        //如果当前数组的第i已经保存进了临时数组，那么跳过，
        //否则把当前项push到临时数组里面
        if (n.indexOf(list[i]) == -1) n.push(list[i]);
      }
      return n;
    },
  },
  methods: {
    //  公共方法
    getUrlKey(name) {
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [",", ""])[1].replace(/\+/g, '%20')) || null;
    },
    getList(param, rect) {
      let url = '/zwmap/conditionQuery'
      if (rect) { // 地址指引跳转
        url = '/zwmap/conditionMapQuery'
      }
      let params={method:url,body:JSON.stringify(this.queryPrams)}
      // queyrList(this.queryPrams).then((res) => {
      unauthorized(params).then((res) => {
        this.Addresslist = [];
        this.SMAddressList = [];
        console.log('res', res)
        if (res.status == 200) {
          if (res.data.data && res.data.data.length > 0) {
            this.loading = false;
            let datalist = res.data.data;
            datalist.forEach((element) => {
              element.position = [element.longitude, element.latitude];
            });
            this.Addresslist = datalist;
            if (this.Addresslist.length > 2) {
              this.SMAddressList.push(this.Addresslist[0], this.Addresslist[1])
            } else {
              this.showAddresslist = true;
            }
            let obj;
            for (let index = 0; index < this.Addresslist.length; index++) {
              if (this.Addresslist[index].name == '汉源县政务服务中心') {
                obj = this.Addresslist[index]
                this.Addresslist.splice(index, 1)
              }
            }
            if (obj) {
              this.Addresslist.unshift(obj);
            }
          } else {
            this.showServiceList = true;
            this.showAdd = false;
            this.loading = false;
          }
        } else {
          this.showAdd = false;
          this.loading = false;
          this.$message.error('查询失败，请重试！')
        }
      });
    },
    // 地图查询事项  post  参数 name  事项名字或者地址
    Query(name) {
      let obj = {
        name,
      }
      this.ServiceList = [];
      this.SMServiceList = [];
      let params={method:'/zwmap/matterMapEsQuery',body:JSON.stringify(obj)}
      // matterMapQuery(obj).then((res) => {
      unauthorized(params).then((res) => {
        // console.log(res, '事项搜索结果')
        if (res.data.code == 200 && res.data.data.length > 0) {
          let datalist = res.data.data;
          // 分接口获取点位信息
          // let hanYuanMapList = datalist[0].hanYuanMapList || []
          // hanYuanMapList.forEach((el) => {
          //   el.position = [el.longitude, el.latitude];
          // });
          // this.ServiceMap = hanYuanMapList;
          this.getPoint(datalist[0], 0)
          this.ServiceList = datalist;
          if (res.data.data.length > 2) {
            this.SMServiceList.push(res.data.data[0], res.data.data[1]);
            this.showSer = true;
            // this.showServiceList = true;
          } else {
            this.showServiceList = true;
            this.showSer = true;
          }
        } else {
          this.showSer = false;
          this.showAddresslist = true;
        }
      })
    },
    getPoint (item, index) {
      // conditionQuery
      let params={method:'/zwmap/conditionMatterQuery',body:JSON.stringify({mapIds: item.mapIds})}
      unauthorized(params).then((res) => {
        let datalist = res.data.data || [];
            datalist.forEach((element) => {
              element.position = [element.longitude, element.latitude];
            });
            let hanYuanMapList = datalist.splice(0, 1);
            this.ServiceMap = hanYuanMapList;
            this.ServiceList[index].hanYuanMapList = hanYuanMapList;
      })
    },
    changeList(item, index) {
      // console.log(item, index, '??')
      this.keywords = "";
      this.queryPrams.address = "";
      this.display = "none";
      this.queryPrams.type = item.type;
      this.getList(this.queryPrams);
      this.showList = index; //为点击菜单添加样式
      if (item.type != 0) {
        this.showServiceList = false;
        this.showSer = false;
        this.SMServiceList = [];
        this.ServiceList = [];
      }
      this.showAddresslist = true;
      this.showAdd = true;

    },
    async searchFn(val, rect) {
      if (this.queryPrams.type == 0) {
          this.display = "none";
          // this.queryPrams.address = val;
          this.queryPrams.name = val;
          await this.getList(this.queryPrams, rect);
          await this.Query(val)
          this.showAdd = true;
          this.showAddresslist = false;
          this.showServiceList = false;
        } else {
          this.display = "none";
          // this.queryPrams.address = val;
          this.queryPrams.name = val;
          this.getList(this.queryPrams, rect);
          this.showAdd = true;
          this.showAddresslist = true;
          this.showServiceList = false;
        }
    },
    // 查看更多地点
    showMoreAdd() {
      this.showAddresslist = true;
      this.showSer = false;
    },
    // 查看更多事项
    showMoreService() {
      this.showServiceList = true;
      this.showAdd = false;
    },
    // 点击列表地点打开对应点位信息窗
    showInfo(item) {
      // console.log(item,'地点')
      let content = ` <h4> ${item.name} </h4>
      <p><b>电话：</b> ${item.phoneNumbe ? item.phoneNumbe : "暂无"}</p>
      <p><b>地址：</b> ${item.address ? item.address : "暂无"}</p>
      <p><b>办公时间：</b>${item.workTime}</p>
      `;

      let pos = []
      // 取出经纬度并转为数值
      pos.push(Number(item.longitude), Number(item.latitude))
      this.$refs.map.markerClick(content, pos)
    },
    // 点击列表事项打开对应点位信息窗
    showServiceInfo(item, index) {
      let params={method:'/zwmap/conditionMatterQuery',body:JSON.stringify({mapIds: item.mapIds})}
      unauthorized(params).then((res) => {
        let datalist = res.data.data || [];
            datalist.forEach((element) => {
              element.position = [element.longitude, element.latitude];
            });
        let hanYuanMapList = datalist.splice(0, 1);
        if (hanYuanMapList.length == 0) return
        item.hanYuanMapList = hanYuanMapList;
        item.hanYuanMapList.forEach((el) => {
          el.position = [el.longitude, el.latitude];
        });
        let content = ` <h4> ${item.hanYuanMapList[0].name
          } </h4><p><b>电话：</b> ${item.hanYuanMapList[0].phoneNumbe ? item.hanYuanMapList[0].phoneNumbe : "暂无"
          }</p><p><b>地址：</b> ${item.hanYuanMapList[0].address ? item.hanYuanMapList[0].address : "暂无"
          }</p><p style="${item.hanYuanMapList[0].workTime ? "display:inherit" : "display:none"
          }"><b>办公时间：</b>${item.handleTime}</p>`;
        let pos = []
        // 取出经纬度并转为数值
        pos.push(Number(item.hanYuanMapList[0].longitude), Number(item.hanYuanMapList[0].latitude))
        this.$refs.map.markerClick(content, pos)
      })
    },
    // 事项公开
    toDisclosure(item) {
      let that = this;
      // let obj = { topTitle: item.name, deptId: '', id: [item.id] }
      // if (item.deptMatterList && item.deptMatterList.length > 0) {
      //   let obj = { topTitle: item.name, deptId: '',id:[item.id] }
      //   this.$router.push({
      //     name: "Disclosure",
      //     params: obj
      //   });
      //   sessionStorage.setItem('deptObj', JSON.stringify(obj));
      // } else {
      // let obj = { topTitle: item.name, deptId: '',id:[item.id] }
      //   this.$router.push({
      //     name: "Disclosure",
      //     params: obj
      //   });
      // sessionStorage.setItem('deptObj', JSON.stringify(obj));
      // }
      sessionStorage.setItem('topTitle', item.name)
      console.log('item', item)
      let i = that.serviceMapList.findIndex(el => el.name == item.name.slice(0, 2))
      console.log('i', i)
      if (i != -1) {
        that.$router.push({
          name: that.serviceMapList[i].linkName,
        });
      }
    },
    // 事项详情页
    toDetail(id, name) {
      // this.$router.push({
      //   name: "ServiceGuide",
      //   query: { matterId: id, name }
      // })
      let obj = { deptMatterId: id, name };
      this.$router.push({
        name: "ServiceGuide",
        params: { deptMatterId: id, name }
      });
      sessionStorage.setItem('matterDetails', JSON.stringify(obj));
    },
    filterNumber(val) {
      if (val) {
        let index = val.indexOf("：");
        return val.slice(index + 1)
      } else {
        return '暂无'
      }
    },
    toWX() {
      let obj = {
        code: this.dataParms.code
      }
      wxLogin(obj).then((res) => {
        console.log('登录结果', res)
      })
    },
  },
  beforeRouteEnter(to, from, next) {
    let that = this;
    // to:获取你要跳转的路由信息
    // from: 获取你从哪个路由来的信息
    // next: （放行函数）
    // 从办事指南过来，则办理部门名称搜索，并展示点位信息，否则直接放行
    if (from.name == 'ServiceGuide') {
      if (sessionStorage.getItem("matterDetails")) {
        let name = JSON.parse(sessionStorage.getItem("matterDetails")).addressName;
        // that.searchFn(name);
        console.log('name', name)
        next(vm => {
          vm.searchFn(name, true);
          // console.log(vm,'??')
        }); // 直接放行        
      }
    } else {
      next( vm => {
        vm.getList();
      }); // 直接放行
    }
    // 第一种写法
    // next(); // 直接放行
    // 第二种
    // next('/url') //放行到指定的路由

    // console.log(from)
    // console.log(next)
  },
  mounted() {
    // if (sessionStorage.getItem("matterDetails")) {
    //   let name = JSON.parse(sessionStorage.getItem("matterDetails")).name;
    //   this.searchFn(name);
    // } else {
    //   this.getList();
    // }
    // if (this.$route.query.name) {
    //   this.searchFn(this.$route.query.name);
    // } else {
    //   this.getList();
    // }
    // this.getList();
  },
  created() {
    this.$emit('public_header', false);
    this.dataParms.code = this.getUrlKey("code");
    // console.log('code', this.dataParms.code);
    if (this.dataParms.code) {
      this.toWX();
    }
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; 
  background: url(http://www.hanyuan.gov.cn/v2/images/head_bg.jpg) no-repeat center 0;*/
}

.title-text {
  clear: both;
  color: #fff;
  margin: 0 auto;
  width: 750px;
  padding-top: 25px;
}

.detail {
  text-align: left;
  text-indent: 2em;
  font-size: 15px;
  line-height: 22px;
  padding-top: 10px;
}

body,
p {
  margin: 0;
}

a {
  color: #000;
  text-decoration: none;
}

ul,
li {
  margin: 0;
  padding: 0;
}

li {
  list-style: none;
}

.index-cont {
  height: 345px;
  /*width: 1170px;
  margin: 0 auto;*/
  background: url('../assets/img/indexBanner.jpg');
  background-size: 100% 100%;
}

.logo {
  padding-top: 15px;
  float: left;
  margin-left: 210px;
}

.main {
  display: flex;
}

.main_left {
  width: 72%;
  height: 680px;
  margin: 20px;
  position: relative;
}

.main_right {
  z-index: 1000;
  position: absolute;
  background: white;
  width: 25%;
  /* height: 680px; */
  right: 0px;
  margin: 20px;
  /* box-shadow: 0 0 20px 2px #888; */
  box-sizing: border-box;
  border: 1px solid #e5e5e5;
  border-radius: 5px;
}

.main_right .searchBox {
  height: 50px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-sizing: border-box;
}

.main_right .searchBox>input {
  width: 85%;
  height: 40px;
  border-color: #f1f1f1;
  border-radius: 5px;
}

/* 右侧列表 */
.main_left_tab3 {
  overflow-y: scroll;
  max-height: 630px;
  min-height: 150px;
  background-color: #fff;
}

/* .main_left_tab3 div {
  display: none;
} */

.main_left_tab3 div ul {
  margin: 0 10px 10px 10px;
  list-style: none;
  padding: 0;
}

.main_left_tab3 ul li {
  border: 1px solid #e5e5e5;
  /* background: url(../img/map_point.png) no-repeat 9px 15px; */
  /* padding: 10px 0px 10px 40px; */
  padding: 10px;
  border-radius: 10px;
  margin-top: 10px;
  background-color: #fff;
  text-align: left;
}


.type-title {
  text-align: left;
  font-size: 16px;
  font-weight: bold;
  padding: 10px 0 0 0;
}

.main_left_tab3 .zhengwu .more-tips {
  font-size: 13px;
  cursor: pointer;
}

/*.main_left_tab3 ul li:hover {
  background: #0492fa;
  color: #fff;
}*/

.main_left_tab3 .zhengwu #xzfwdt .banshiBtn {
  width: 80px;
  height: 35px;
  display: inline-block;
  text-align: center;
  line-height: 35px;
  background-color: #0090ff;
  color: #fff;
  border-radius: 5px;
  margin-right: 10px;
  /*display: none;*/
  /*隐藏办事指南*/
}

.banshiBtn {
  width: 80px;
  height: 35px;
  display: inline-block;
  text-align: center;
  line-height: 35px;
  background-color: #0090ff;
  color: #fff;
  border-radius: 5px;
  margin-right: 10px;
  cursor: pointer;
}

.main_left_tab3 .zhengwu #xzfwdt li>p:nth-child(1) {
  display: flex;
  justify-content: space-between;
}

/* .main_left_tab3 ul li:hover {
	background-color: #f2f2f2;
	cursor: pointer;
} */

.main_left_tab3 ul li h4 {
  /* color: #fff; */
  font-weight: 400;
}

.service-titleBox {
  display: flex;
  align-items: center;
}

.service-titleBox-title {
  font-size: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  width: 70%;
}

.main_left_tab3 ul p {
  line-height: 25px;
  font-size: 14px;
  /* color: #fff; */
}

.main_left_tab3 ul b {
  font-weight: 400;
}

.main_left .mapNavBar {
  position: absolute;
  z-index: 1000;
  width: 400px;
  margin: 20px;
}

.main_left .mapNavBar>ul {
  display: flex;
  justify-content: space-around;
}

.main_left .mapNavBar>ul>li {
  /* background: #0492FA;
    color: #fff; */
  padding: 5px;
  border-radius: 5px;
  width: 80px;
  text-align: center;
  background: #fff;
  color: #000;
  font-weight: bold;
  cursor: pointer;
}

.MapLogo {
  position: absolute;
  bottom: 10px;
  left: 10px;
  background-color: #fff;
  width: 155px;
  text-align: center;
  height: 50px;
  line-height: 50px;
  font-weight: bold;
  font-size: 20px;
  border-radius: 5px;
}

/* 地图logo隐藏 */
.amap-logo,
.amap-copyright {
  display: none !important;
}

/* 地图点位图标 */
/* .amap-icon {width: 19px !important;height: 32px !important;} */
/* .amap-icon img{width:100% !important;}  */
.on {
  background: #0492fa !important;
  color: #fff !important;
}

/* 地图信息窗样式 */
.amap-info-contentContainer {
  width: 465px;
  /* height: 120px; */
  /* background-color: #fff;
  border: 1px solid #aaa;
  padding: 10px;
  text-align: left; */
}

.amap-info-contentContainer h4 {
  color: #148aff;
  font-size: 16px;
  line-height: 25px;
  font-weight: 400;
  margin: 0;
}

.amap-info-contentContainer b {
  font-weight: 400;
  color: #148aff;
}

.amap-info-contentContainer p {
  margin: 10px 0;
}
</style>
